<template>
    <v-container fluid>
        <v-layout>
            <v-flex xs6>
                <v-text-field v-model="domicilio.calle" label="Calle" required :prepend-icon="iconName" :disabled="!editMode"></v-text-field>
                <v-text-field v-model="domicilio.codigoPostal" label="C.P." required :disabled="!editMode"></v-text-field>
                <v-autocomplete v-model="domicilio.provinciaId" :items="provincias" 
                    item-text="nombre" item-value="id" label="Provincia" placeholder="Seleccione una provincia" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
            </v-flex>
            <v-flex xs6>
                <v-text-field v-model="domicilio.localidad" label="Localidad" required :disabled="!editMode"></v-text-field>
                <v-text-field v-model="domicilio.partido" label="Partido" required :disabled="!editMode"></v-text-field>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'

export default {
  data: () => ({
    loading: false,
    domicilio: {},
    provincias:[]
  }),
  props: {
    value: {
      type: Object,
      required: false
    },
    propName:{
        type: String,
        required: true,
        default: 'domicilio'
    },
    label: {
      type: String,
      default: 'Domicilio'
    },
    iconName: {
      type: String,
      default: 'home'
    },
    editMode: {
      type: Boolean,
      default: true
    }
  },
  watch:{
      'value.domicilio': function(item){          
        this.setDomicilio()
      }
  },
  computed: {  
  },
  created () {
    // todo: cargar provincias
    this.loadProvincias();

    // cargo el modelo
    this.setDomicilio()
  },
  methods: {
      setDomicilio(){        
        if(!this.value[this.propName]){ // Si el domicilio no está cargado, creo la propiedad 
            this.domicilio = {
                calle: '',
                localidad: '',
                codigoPostal: '',
                partido: '',
                provinciaId: ''                
            }
            
            this.value[this.propName] = this.domicilio
        }
        this.domicilio = this.value[this.propName]
      },
      async loadProvincias(){
        this.loading = true
        try {
            var result = await http.get('provincias'); // traigo todas
            this.provincias = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
      }
  }
}

</script>